// PRIVATE DATA!
// DO NOT IMPORT THIS DIRECTLY IN YOUR PROJECT!
// IT CAN BE CHANGED AT ANY TIME
export default /\)\sVersion\/([\d.]+\d)\s(Mobile\/[\dE.]+\s)?Safari\/[\d.]+\d$/;
